class WorkSafeBcPhysicianReportModelMetadata {
    public HasPhysicianContributedToForm: boolean;

    public constructor(init?: Partial<WorkSafeBcPhysicianReportModelMetadata>) {
        this.HasPhysicianContributedToForm = false;
        Object.assign(this, init);
    }
}

export { WorkSafeBcPhysicianReportModelMetadata };
